import { render } from "./Toggle.vue?vue&type=template&id=cf116ab6"
import script from "./Toggle.vue?vue&type=script&lang=ts"
export * from "./Toggle.vue?vue&type=script&lang=ts"

import "./Toggle.vue?vue&type=style&index=0&id=cf116ab6&lang=scss"
script.render = render

export default script